"use client"

/**
 * Fly a token from a source element toward the cart icon, then pulse the cart.
 */
export function flyToCart(fromEl: HTMLElement | null, imageUrl?: string | null) {
  if (typeof window === "undefined" || !fromEl) return
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    pulseCart()
    return
  }

  const cart = document.querySelector<HTMLElement>("[data-bb-cart]")
  if (!cart) {
    pulseCart()
    return
  }

  const from = fromEl.getBoundingClientRect()
  const to = cart.getBoundingClientRect()
  const size = 44
  const startX = from.left + from.width / 2 - size / 2
  const startY = from.top + from.height / 2 - size / 2
  const endX = to.left + to.width / 2 - size / 2
  const endY = to.top + to.height / 2 - size / 2

  const token = document.createElement("div")
  token.className = "bb-fly-token"
  token.setAttribute("aria-hidden", "true")
  if (imageUrl) {
    token.style.backgroundImage = `url("${imageUrl}")`
  }
  token.style.left = `${startX}px`
  token.style.top = `${startY}px`
  token.style.width = `${size}px`
  token.style.height = `${size}px`
  document.body.appendChild(token)

  // Force layout then animate
  token.getBoundingClientRect()
  token.style.transform = `translate3d(${endX - startX}px, ${endY - startY}px, 0) scale(0.35)`
  token.style.opacity = "0.15"

  window.setTimeout(() => {
    token.remove()
    pulseCart()
  }, 720)
}

function pulseCart() {
  const cart = document.querySelector<HTMLElement>("[data-bb-cart]")
  if (!cart) return
  cart.classList.remove("bb-cart-pulse")
  // reflow to restart animation
  void cart.offsetWidth
  cart.classList.add("bb-cart-pulse")
  window.setTimeout(() => cart.classList.remove("bb-cart-pulse"), 700)
}
